import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { AuthService } from './../../../../services/auth.service';
import { CollaboratorService } from './../../../../rest/api/collaborator.service';
import { HelperService } from './../../../../services/helper.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';

import * as _ from 'lodash';
@Component({
  selector: 'app-invite-collaborators',
  templateUrl: './invite-collaborators.component.html',
  styleUrls: ['./invite-collaborators.component.scss']
})
export class InviteCollaboratorsComponent implements OnInit {
  @Input() collaboratorsData;
  @Output() inviteCollaboratorsEmit = new EventEmitter();

  accessToken: any;

  isSubmitting = false;
  isSubmitted = false;
  errors = [];
  successMsg: string;
  errorMsg: string;

  inviteCollaboratorForm: FormGroup;

  showPermission = false;

  constructor(
    public fb: FormBuilder,
    private authService: AuthService,
    public helperService: HelperService,
    public collaboratorService: CollaboratorService,

  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.inviteCollaboratorFormInit();
    this.setAdminUserTypeValidators();
  }

  inviteCollaboratorFormInit() {
    this.inviteCollaboratorForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      message: [''],
      role: ['', [Validators.required]],
      invoice_permission: [false],
      billing_permission: [false],
      email_permission: [false]
    });
  }

  submit(value) {
    if (!this.inviteCollaboratorForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    this.inviteCollaboratorDetail(data);
  }

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }

  inviteCollaboratorDetail(data) {
    let formData;
    formData = {
      email: data.email,
      message: data.message,
      role: data.role
    };
    if (data.role === 'admin') {
      formData.invoice_permission = data.invoice_permission ? true : false;
      formData.billing_permission = data.billing_permission ? true : false;
      formData.email_permission = data.email_permission ? true : false;
    }

    data = this.helperService.updateJsonFormat(formData);
    this.collaboratorService.inviteCollaborator({
      Authorization: this.accessToken,
      body: data
    }).subscribe((response: any) => {
      this.inviteCollaboratorsEmit.emit(response.data);
      this.resetForm();
      this.successMsg = 'Invitation sent! You can edit Space access for invited collaborators on the pending tab.';
      setTimeout(() => {
        this.resetErrors();
      }, 5000);
    }, err => {
      this.handleErrors(err);
    });
  }

  setAdminUserTypeValidators() {
    const invoicePermission = this.inviteCollaboratorForm.get('invoice_permission');
    const billingPermission = this.inviteCollaboratorForm.get('billing_permission');
    const emailPermission = this.inviteCollaboratorForm.get('email_permission');

    this.inviteCollaboratorForm.get('role').valueChanges
      .subscribe(role => {
        if (role === 'admin') {
          this.showPermission = true;
          invoicePermission.enable();
          billingPermission.enable();
          emailPermission.enable();
        } else {
          this.showPermission = false;
          invoicePermission.disable();
          billingPermission.disable();
          emailPermission.disable();
        }
        invoicePermission.updateValueAndValidity();
        billingPermission.updateValueAndValidity();
        emailPermission.updateValueAndValidity();
      });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.inviteCollaboratorForm.reset({ role: ''});
  }

  handleErrors(err) {
    if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errors = err.error.errors;
    } else if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'This user is already a collaborator in your company.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }
}
